const LEFT_OFFSET = 100;
const COLORS_PALETTE = [
  "#FF0000",
  "#00FF00",
  "#00FFFF",
  "#FFFF00",
  "#FFBF00",
  "#FF00FF",
  "#FFFFFF",
  "#000000",
  "#0000FF",
  "#CC0000",
  "#9FFF0A",
  "#00CCCC",
  "#F2DB18",
  "#FF9900",
  "#FFC0CB",
  "#DADBDD",
  "#969DA6",
  "#00B500",
  "#5E36FF",
  "#7C0A02",
  "#72BE44",
  "#0091FF",
  "#283D55",
  "#CC7722",
  "#990099",
  "#A8B8C8",
  "#4B4F58",
  "#808080",
];
const TEXT_PALETTE = [null, ...COLORS_PALETTE];
const BG_PALETTE = ["transparent", ...COLORS_PALETTE];

export { LEFT_OFFSET, COLORS_PALETTE, TEXT_PALETTE, BG_PALETTE };
